export interface CourseModule {
  number: string
  title: string
  hook: string
  description: string
  tags: string[]
}

export const modules: CourseModule[] = [
  {
    number: '01',
    title: 'Senior Fitness Foundations™',
    hook: 'Build every session on a stronger structure.',
    description:
      'Organize warm-ups, strength, mobility, balance, functional movement, conditioning, and recovery into classes that make sense for older adults.',
    tags: [
      'Session Structure',
      'Safety',
      'Mobility',
      'Strength',
      'Balance',
      'Functional Training',
    ],
  },
  {
    number: '02',
    title: 'Senior Exercise Library™',
    hook: 'Stop searching for your next exercise.',
    description:
      'Access a structured library of 250+ senior-friendly exercises organized by training goal, ability level, movement pattern, and progression.',
    tags: [
      'Strength',
      'Mobility',
      'Balance',
      'Coordination',
      'Functional Movement',
      'Adaptations',
    ],
  },
  {
    number: '03',
    title: 'Ready-To-Use Session Vault™',
    hook: "Need tomorrow's class? It's already there.",
    description:
      'Choose from 100 complete senior fitness sessions with clear structure, exercise selection, timing, and progression options.',
    tags: [
      '30-Minute',
      '45-Minute',
      '60-Minute',
      'Strength',
      'Mobility',
      'Balance',
      'Mixed Sessions',
    ],
  },
  {
    number: '04',
    title: 'Progression & Adaptation System™',
    hook: 'One group. Different abilities. Clear options.',
    description:
      'Learn how to progress or simplify exercises so your sessions can work more effectively across different fitness and mobility levels.',
    tags: [
      'Regressions',
      'Progressions',
      'Intensity',
      'Mobility',
      'Balance',
      'Mixed Abilities',
    ],
  },
  {
    number: '05',
    title: '12-Month Programming System™',
    hook: 'Stop wondering what comes next.',
    description:
      'Move beyond isolated workouts with structured programming that helps you organize weeks and months of senior fitness training.',
    tags: [
      'Weekly Planning',
      'Monthly Goals',
      'Training Phases',
      'Progressions',
      'Variety',
      'Long-Term Structure',
    ],
  },
  {
    number: '06',
    title: 'Professional Coach Toolkit™',
    hook: 'Keep the coaching side organized too.',
    description:
      'Use practical resources for assessments, class planning, participant progress, attendance, session notes, and program organization.',
    tags: [
      'Assessments',
      'Planners',
      'Trackers',
      'Checklists',
      'Progress Notes',
      'Coaching Resources',
    ],
  },
]
